import React from "react";
import { Box, Typography, Container } from "@mui/material";

const PrivacyPolicyPage = () => {
  return (
    <Box sx={{ py: 6, backgroundColor: "#f4f6f8" }}>
      <Container maxWidth="md">

        <Typography
          variant="h2"
          component="h1"
          sx={{
            fontSize: { xs: "1.6rem", sm: "2rem", md: "2.5rem" },
            fontWeight: "bold",
            color: "#222",
            mb: 3,
          }}
        >
          Política de Privacidad – FactuSysDR
        </Typography>

        <Typography sx={{ mb: 4, color: "#555" }}>
          FactuSysDR protege la información almacenada dentro del sistema de
          facturación electrónica y garantiza el uso responsable de los datos.
        </Typography>

        <Section
          title="1. Información almacenada"
          text="FactuSysDR almacena únicamente información necesaria para la operación del sistema, incluyendo datos tributarios, comprobantes electrónicos y registros ingresados por el usuario."
        />

        <Section
          title="2. No comercialización de datos"
          text="FactuSysDR no vende, comparte ni utiliza la información almacenada con fines comerciales o publicitarios. Los datos pertenecen exclusivamente al cliente."
        />

        <Section
          title="3. Bases de datos independientes"
          text="Cada plan opera sobre una base de datos independiente con el objetivo de reducir riesgos de acceso no autorizado y mejorar la seguridad de la información."
        />

        <Section
          title="4. Uso de rastreadores"
          text="FactuSysDR no utiliza cookies de seguimiento publicitario ni herramientas externas de rastreo. Solo se emplean cookies técnicas necesarias para autenticación del sistema."
        />

        <Section
          title="5. Seguridad de contraseñas"
          text="Las contraseñas son administradas exclusivamente por los usuarios y pueden modificarse en cualquier momento. FactuSysDR no tiene acceso a credenciales privadas."
        />

        <Section
          title="6. Control del usuario"
          text="El usuario puede actualizar su información, modificar credenciales y descargar sus documentos electrónicos mientras su plan esté activo."
        />

        <Section
          title="7. Protección tributaria"
          text="FactuSysDR aplica medidas técnicas de seguridad para proteger comprobantes electrónicos, archivos XML autorizados y datos fiscales almacenados en la plataforma."
        />

        <Section
          title="8. Conservación de información"
          text="La información permanece disponible únicamente mientras el plan esté activo. Tras la cancelación del servicio el acceso será suspendido conforme a los términos del sistema."
        />

        <Section
          title="9. Responsabilidad del usuario"
          text="El usuario es responsable de la exactitud de la información tributaria registrada y del cumplimiento de sus obligaciones ante el SRI."
        />

        <Section
          title="10. Cambios en la política"
          text="FactuSysDR podrá actualizar esta política cuando sea necesario para mejorar la seguridad del sistema o adaptarse a cambios legales."
        />

        <Section
          title="11. Contacto"
          text="Para consultas relacionadas con privacidad puede comunicarse a contacto@factusysdr.com."
        />

      </Container>
    </Box>
  );
};

const Section = ({ title, text }) => (
  <>
    <Typography
      variant="h5"
      sx={{
        fontWeight: "bold",
        mb: 1,
        color: "#222",
      }}
    >
      {title}
    </Typography>

    <Typography sx={{ mb: 2 }}>
      {text}
    </Typography>
  </>
);

export default PrivacyPolicyPage;